import {
  SimpleForm,
  TextInput,
  Datagrid,
  List,
  TextField,
  Create,
  SelectInput,
  FunctionField,
  useDataProvider,
} from "react-admin";
import { useState, useEffect } from "react";
import { Chip } from "@mui/material";

const tenantTypeMap = {
  RESTAURANT: "Restaurant",
  RETAIL: "Retail",
};

// Location count field component
const TenantLocationCount = ({ record }) => {
  const dataProvider = useDataProvider();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    
    const fetchCount = async () => {
      if (!record?.id) {
        setCount(0);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const result = await dataProvider.getList("location", {
          filter: { tenantId: record.id },
          pagination: { page: 1, perPage: 1 },
          sort: { field: "name", order: "ASC" },
        });
        
        if (!cancelled) {
          setCount(result.total);
          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          setCount(0);
          setLoading(false);
        }
      }
    };

    fetchCount();

    return () => {
      cancelled = true;
    };
  }, [record?.id, dataProvider]);

  if (loading) return <span>...</span>;
  return <Chip label={count} size="small" />;
};

// Brand count field component
const TenantBrandCount = ({ record }) => {
  const dataProvider = useDataProvider();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    
    const fetchCount = async () => {
      if (!record?.id) {
        setCount(0);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const result = await dataProvider.getList("brand", {
          filter: { tenantId: record.id },
          pagination: { page: 1, perPage: 1 },
          sort: { field: "name", order: "ASC" },
        });
        
        if (!cancelled) {
          setCount(result.total);
          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          setCount(0);
          setLoading(false);
        }
      }
    };

    fetchCount();

    return () => {
      cancelled = true;
    };
  }, [record?.id, dataProvider]);

  if (loading) return <span>...</span>;
  return <Chip label={count} size="small" color="primary" />;
};

export const TenantList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField label="Name" source="name" />
      <FunctionField
        label="Type"
        render={(record) => tenantTypeMap[record.type] || "Unknown"}
      />
      <FunctionField
        label="Brands"
        render={(record) => <TenantBrandCount record={record} />}
      />
      <FunctionField
        label="Locations"
        render={(record) => <TenantLocationCount record={record} />}
      />
    </Datagrid>
  </List>
);

export const TenantCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput label="Name" source="name" fullWidth required />
      <SelectInput
        source="type"
        label="Type"
        choices={[
          { id: "RESTAURANT", name: "Restaurant" },
          { id: "RETAIL", name: "Retail" },
        ]}
        fullWidth
        required
      />
      <TextInput label="Description" source="description" fullWidth multiline />
    </SimpleForm>
  </Create>
);
